import { GET_UNDERWRITER_REVIEW_LINK } from '../../constants/actions/policy';

export function getUnderwriterReviewLink(payload) {
    return {
        type: GET_UNDERWRITER_REVIEW_LINK,
        payload,
    };
}
